<sb-card [loading]=loading>
  <div card-header>
    <div class="d-flex flex-row">
      <div class="mr-2"><b>{{'nav.network.tracker.details.visitors' | translate}}</b></div>
    </div>
  </div>
  <div card-header-more *ngPermissions="permissionService.Permission.visitor_tracker_visitor_aggregation"
       class="d-flex justify-content-center align-items-center">
    <sb-local-date-range-input [from]="from" [till]="till" (dateChange)="handleDateChange($event)">

    </sb-local-date-range-input>
    <div *ngIf="editMode===1" class="ml-2">
      <button class="btn btn-default" (click)="cancel()">
        {{'lang.globals.cancel' | translate}}
        <sb-icon icon="cancel"></sb-icon>
      </button>
    </div>
    <div class="ml-2">
      <button class="btn btn-primary" (click)="edit()"
              [disabled]="editMode===1? updatedTrackedVisitors?.length === 0 : false">
        <div *ngIf="editMode ===1">
          {{'lang.globals.save' |translate}}
          <sb-icon icon="save"></sb-icon>
        </div>
        <div *ngIf="editMode !==1">
          {{'lang.globals.edit' |translate}}
          <sb-icon icon="edit"></sb-icon>
        </div>
      </button>
    </div>
  </div>
  <div card-body>
    <ng-scrollbar>

      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{'lang.globals.date' | translate}}</th>
          <th *ngFor="let slot of hourTimeSlot; index as i">{{slot}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let date of dateRange" sb-comp-tracker-values-line [tracker]="tracker"
            (changedLineEmitter)="handleTrackerValueChanged($event)"
            [trackedVisitor]="getTrackedVisitor(date)" [date]="date" [editMode]="editMode">
        </tr>
        </tbody>
      </table>
    </ng-scrollbar>
    <!--
    <div class="row">
      <div class="col-xxl-6 col-xl-8 col-lg-8 col-md-12">
        <ng-container *ngIf="trackedVisitors && trackedVisitors.length > 0">
          <div class="flex-grow-1 w-100">
            <div class="mt-4">
              <h5 class="mb-2">{{'lang.globals.data' | translate}}</h5>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.identifier' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="trackedVisitor.count">
                    {{trackedVisitor.count}}
                  </ng-container>
                  <i *ngIf="!trackedVisitor.count">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.timezone' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="trackedVisitor.unique">
                    {{trackedVisitor.unique}}
                  </ng-container>
                  <i *ngIf="!trackedVisitor.unique">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{'lang.globals.timezone' | translate}}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="trackedVisitor.dwellTime">
                    {{trackedVisitor.dwellTime}}
                  </ng-container>
                  <i *ngIf="!trackedVisitor.dwellTime">
                    <a>&#91;{{'lang.deviceDetails.nDef' | translate}}.&#093;</a>
                  </i>
                </span>
              </div>

            </div>
          </div>
        </ng-container>
      </div>
    </div>
      -->
  </div>
</sb-card>
